import { defineStore } from "pinia";
import { useAuthStore } from "./auth";

export const useQueryManager = defineStore("query-manager", () => {
	const activated = ref(false);

	const auth = useAuthStore();

	const enabled = computed(() => {
		if (!activated.value) return false;

		return auth.isAuth;
	});

	function deactivate() {
		activated.value = false;
	}
	function activate() {
		activated.value = true;
	}

	let chaining = false;
	async function chainInvalidation(fn: () => Promise<void>) {
		// Escape hatch for nested chain call
		if (chaining) {
			return await fn();
		}

		try {
			chaining = true;
			deactivate();
			await fn();
		} finally {
			chaining = false;
			activate();
		}
	}

	return {
		enabled,
		deactivate,
		activate,
		chainInvalidation,
	};
});
